import { render, staticRenderFns } from "./PagamentoDesassociarDespesa.vue?vue&type=template&id=48e0503e"
import script from "./PagamentoDesassociarDespesa.vue?vue&type=script&lang=js"
export * from "./PagamentoDesassociarDespesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports